import styled from "styled-components";

import { colors } from "../../../constants/colors";

export const StyledCard = styled.div`
  background: ${colors.white};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;

  padding: 2rem;
  box-sizing: border-box;
`;
